const allAttributes = [
  {
    parentOlxId: 1473,
    olxId: 2581,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Procesor" },
      { value: 2, label: "Kontroler" },
      { value: 3, label: "Pumpa" },
      { value: 4, label: "Instalacija" },
      { value: 5, label: "Kućište" },
      { value: 6, label: "Senzor" },
      { value: 7, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1446,
    olxId: 5078,
    name: "jacina-ah",
    inputType: "number",
    options: null,
  },
  {
    parentOlxId: 1443,
    olxId: 2134,
    name: "namjena",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi namjenu" },
      { value: 1, label: "Vozac" },
      { value: 2, label: "Suvozac" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1768,
    olxId: 2767,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1462,
    olxId: 2105,
    name: "pozicija",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi pozicija" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Zadnji" },
      { value: 3, label: "Za gepek" },
      { value: 4, label: "Za haubu" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1462,
    olxId: 2570,
    name: "strana",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi stranu" },
      { value: 1, label: "Desni" },
      { value: 2, label: "Lijevi" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1462,
    olxId: 2571,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Uljni" },
      { value: 2, label: "Gasni" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1438,
    olxId: 2814,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1524,
    olxId: 2646,
    name: "dijelovi",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi dijelovi" },
      { value: 1, label: "Regulator" },
      { value: 2, label: "Španer" },
      { value: 3, label: "Ležaj" },
      { value: 4, label: "Presostat" },
      { value: 5, label: "Reostat" },
      { value: 6, label: "Relej" },
      { value: 7, label: "Komplet" },
      { value: 8, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2587,
    olxId: 6947,
    name: "vrsta-opreme",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu-opreme" },
      { value: 1, label: "Autofolija" },
      { value: 2, label: "Alat za postavljanje folije" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 942,
    olxId: 2794,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Pranje" },
      { value: 2, label: "Poliranje" },
      { value: 3, label: "Sjaj" },
      { value: 4, label: "Miris" },
      { value: 5, label: "Sprej" },
      { value: 6, label: "Krpa" },
      { value: 7, label: "Osvježivač" },
      { value: 8, label: "Marker" },
      { value: 9, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2028,
    olxId: 4730,
    name: "vrsta-za",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu-za" },
      { value: 1, label: "Sjedište" },
      { value: 2, label: "Volan" },
      { value: 3, label: "Točak" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2483,
    olxId: 6848,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Baglame vrata" },
      { value: 2, label: "Zakačke vrata" },
      { value: 3, label: "Klizači vrata" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1456,
    olxId: 2117,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednji desni" },
      { value: 2, label: "Zadnji desni" },
      { value: 3, label: "Prednji lijevi" },
      { value: 4, label: "Zadnji lijevi" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 944,
    olxId: 1856,
    name: "boja",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi boju" },
      { value: 1, label: "Neutralna" },
      { value: 2, label: "Bež" },
      { value: 3, label: "Bijela" },
      { value: 4, label: "Crna" },
      { value: 5, label: "Crvena" },
      { value: 6, label: "Ljubičasta" },
      { value: 7, label: "Narandžasta" },
      { value: 8, label: "Plava" },
      { value: 9, label: "Siva" },
      { value: 10, label: "Smeđa" },
      { value: 11, label: "Srebrena" },
      { value: 12, label: "Zelena" },
      { value: 13, label: "Zlatna" },
      { value: 14, label: "Žuta" },
      { value: 15, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 944,
    olxId: 2123,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Branik prednji" },
      { value: 2, label: "Branik zadnji" },
      { value: 3, label: "Spojler prednji" },
      { value: 4, label: "Spojler zadnji" },
      { value: 5, label: "Spojler gepeka" },
      { value: 6, label: "Spojler zadnje šajbe" },
      { value: 7, label: "Spojler krovni" },
      { value: 8, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1614,
    olxId: 2707,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Brava" },
      { value: 2, label: "Ključ" },
      { value: 3, label: "Oklop" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1811,
    olxId: 2785,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1440,
    olxId: 2129,
    name: "strana",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi stranu" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Zadnji" },
    ],
  },
  {
    parentOlxId: 1789,
    olxId: 2779,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Metalni" },
      { value: 2, label: "Plastični" },
      { value: 3, label: "Gumeni" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1789,
    olxId: 2777,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Motora" },
      { value: 2, label: "Vrata" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1472,
    olxId: 2579,
    name: "strana",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi stranu" },
      { value: 1, label: "Desna" },
      { value: 2, label: "Lijeva" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1472,
    olxId: 2107,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Zadnji" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1486,
    olxId: 2098,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Ručna" },
      { value: 2, label: "Hidraulična" },
      { value: 3, label: "Zračna" },
      { value: 4, label: "Mehanička" },
      { value: 5, label: "Četverostubna" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1478,
    olxId: 2600,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Plin" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2491,
    olxId: 6785,
    name: "namjena",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi namjenu" },
      { value: 1, label: "Ecu motora" },
      { value: 2, label: "Ecu mjenjača" },
      { value: 3, label: "Ecu volana" },
      { value: 4, label: "Ecu vrata" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 939,
    olxId: 1847,
    name: "sijalica",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi tip sijalice" },
      { value: 1, label: "Obična" },
      { value: 2, label: "Xenon" },
      { value: 3, label: "BiXenon" },
      { value: 4, label: "LED" },
      { value: 5, label: "HID" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 939,
    olxId: 2121,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Far desni" },
      { value: 2, label: "Far lijevi" },
      { value: 3, label: "Oba fara" },
      { value: 4, label: "Štopka desna" },
      { value: 5, label: "Štopka lijeva" },
      { value: 6, label: "Obje štopke" },
      { value: 7, label: "Dnevna svjetla DRL" },
      { value: 8, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 937,
    olxId: 1843,
    name: "broj-rupa",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi broj-rupa" },
      { value: 1, label: "3" },
      { value: 2, label: "4" },
      { value: 3, label: "5" },
      { value: 4, label: "Više" },
    ],
  },
  {
    parentOlxId: 937,
    olxId: 1840,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Čelične" },
      { value: 2, label: "Aluminijske" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 937,
    olxId: 1842,
    name: "raspon-sarafa",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi raspon-sarafa" },
      { value: 1, label: "4x98" },
      { value: 2, label: "4x100" },
      { value: 3, label: "4x108" },
      { value: 4, label: "4x112" },
      { value: 5, label: "4x114.3" },
      { value: 6, label: "4x113.30" },
      { value: 7, label: "4x120" },
      { value: 8, label: "5x98" },
      { value: 9, label: "5x100" },
      { value: 10, label: "5x105" },
      { value: 11, label: "5x114.3" },
      { value: 12, label: "5x108" },
      { value: 13, label: "5x110" },
      { value: 14, label: "5x112" },
      { value: 15, label: "5x115" },
      { value: 16, label: "5x120" },
      { value: 17, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 937,
    olxId: 1839,
    name: "velicina-inch",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi velicina-inch" },
      { value: 1, label: "13" },
      { value: 2, label: "14" },
      { value: 3, label: "15" },
      { value: 4, label: "16" },
      { value: 5, label: "17" },
      { value: 6, label: "18" },
      { value: 7, label: "19" },
      { value: 8, label: "20" },
      { value: 9, label: "21" },
      { value: 10, label: "22" },
      { value: 11, label: "23" },
      { value: 12, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1616,
    olxId: 2716,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Čelične" },
      { value: 2, label: "Aluminijske" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1616,
    olxId: 5016,
    name: "vrsta-gume",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu-gume" },
      { value: 1, label: "Ljetne" },
      { value: 2, label: "Zimske" },
      { value: 3, label: "All season (Cjelogodišnje)" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1616,
    olxId: 5013,
    name: "broj-rupa",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi broj-rupa" },
      { value: 1, label: "3" },
      { value: 2, label: "4" },
      { value: 3, label: "5" },
      { value: 4, label: "Više" },
    ],
  },
  {
    parentOlxId: 1616,
    olxId: 5014,
    name: "raspon-sarafa",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi raspon-sarafa" },
      { value: 1, label: "4x98" },
      { value: 2, label: "4x100" },
      { value: 3, label: "4x108" },
      { value: 4, label: "4x100/4x108" },
      { value: 5, label: "4x112" },
      { value: 6, label: "4x114.3" },
      { value: 7, label: "4x100/4x114.30" },
      { value: 8, label: "4x108/4x113.30" },
      { value: 9, label: "4x120" },
      { value: 10, label: "5x98" },
      { value: 11, label: "5x100" },
      { value: 12, label: "5x105" },
      { value: 13, label: "5x114.3" },
      { value: 14, label: "5x108" },
      { value: 15, label: "5x110" },
      { value: 16, label: "5x112" },
      { value: 17, label: "5x115" },
      { value: 18, label: "5x120" },
      { value: 19, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1616,
    olxId: 5012,
    name: "velicina",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi velicina" },
      { value: 1, label: "13" },
      { value: 2, label: "14" },
      { value: 3, label: "15" },
      { value: 4, label: "16" },
      { value: 5, label: "17" },
      { value: 6, label: "18" },
      { value: 7, label: "19" },
      { value: 8, label: "20" },
      { value: 9, label: "21" },
      { value: 10, label: "22" },
      { value: 11, label: "23" },
      { value: 12, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1434,
    olxId: 2157,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Zrak" },
      { value: 2, label: "Ulje" },
      { value: 3, label: "Gorivo" },
      { value: 4, label: "Klima" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1624,
    olxId: 2743,
    name: "strana",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi stranu" },
      { value: 1, label: "Desna" },
      { value: 2, label: "Lijeva" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1749,
    olxId: 2754,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Za motor" },
      { value: 2, label: "Za sjedište" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 940,
    olxId: 1849,
    name: "velicina-precnik-promjer",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi velicina-precnik-promjer" },
      { value: 1, label: "13" },
      { value: 2, label: "14" },
      { value: 3, label: "15" },
      { value: 4, label: "16" },
      { value: 5, label: "17" },
      { value: 6, label: "18" },
      { value: 7, label: "19" },
      { value: 8, label: "20" },
      { value: 9, label: "21" },
      { value: 10, label: "22" },
      { value: 11, label: "23" },
      { value: 12, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 940,
    olxId: 2919,
    name: "visina",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi visinu" },
      { value: 1, label: "25" },
      { value: 2, label: "30" },
      { value: 3, label: "35" },
      { value: 4, label: "40" },
      { value: 5, label: "45" },
      { value: 6, label: "50" },
      { value: 7, label: "55" },
      { value: 8, label: "60" },
      { value: 9, label: "65" },
      { value: 10, label: "70" },
      { value: 11, label: "75" },
      { value: 12, label: "80" },
      { value: 13, label: "85" },
      { value: 14, label: "90" },
      { value: 15, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 940,
    olxId: 1848,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Ljetne" },
      { value: 2, label: "Zimske" },
      { value: 3, label: "All season (Cjelogodišnje)" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 940,
    olxId: 2918,
    name: "sirina",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi sirinu" },
      { value: 1, label: "135" },
      { value: 2, label: "145" },
      { value: 3, label: "155" },
      { value: 4, label: "165" },
      { value: 5, label: "175" },
      { value: 6, label: "185" },
      { value: 7, label: "195" },
      { value: 8, label: "205" },
      { value: 9, label: "215" },
      { value: 10, label: "225" },
      { value: 11, label: "235" },
      { value: 12, label: "245" },
      { value: 13, label: "255" },
      { value: 14, label: "265" },
      { value: 15, label: "275" },
      { value: 16, label: "285" },
      { value: 17, label: "295" },
      { value: 18, label: "305" },
      { value: 19, label: "315" },
      { value: 20, label: "325" },
      { value: 21, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1457,
    olxId: 2546,
    name: "boja",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi boju" },
      { value: 1, label: "Neutralna" },
      { value: 2, label: "Bež" },
      { value: 3, label: "Bijela" },
      { value: 4, label: "Crna" },
      { value: 5, label: "Crvena" },
      { value: 6, label: "Ljubičasta" },
      { value: 7, label: "Narandžasta" },
      { value: 8, label: "Plava" },
      { value: 9, label: "Siva" },
      { value: 10, label: "Smeđa" },
      { value: 11, label: "Srebrena" },
      { value: 12, label: "Zelena" },
      { value: 13, label: "Zlatna" },
      { value: 14, label: "Žuta" },
      { value: 15, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1469,
    olxId: 2152,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Klime" },
      { value: 2, label: "Vode" },
      { value: 3, label: "Zraka" },
      { value: 4, label: "Ulja" },
      { value: 5, label: "Kabine" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 945,
    olxId: 2504,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Čelik" },
      { value: 2, label: "Aluminizirani Čelik" },
      { value: 3, label: "Inox" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 945,
    olxId: 1858,
    name: "proizvodnja",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi proizvodnja" },
      { value: 1, label: "Fabrička" },
      { value: 2, label: "Ručna" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1476,
    olxId: 2592,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Metal" },
      { value: 2, label: "Plastika" },
      { value: 3, label: "Guma" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1476,
    olxId: 2591,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Za ventile" },
      { value: 2, label: "Za šarafe" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1766,
    olxId: 2764,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Čelik" },
      { value: 2, label: "Aluminij" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1766,
    olxId: 2765,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1436,
    olxId: 2842,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1788,
    olxId: 2768,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1487,
    olxId: 2096,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Zadnji" },
      { value: 3, label: "Glavni" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1474,
    olxId: 2585,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Kompletan set" },
      { value: 2, label: "Zamajac" },
      { value: 3, label: "Lamela" },
      { value: 4, label: "Druk ležaj" },
      { value: 5, label: "Korpa" },
      { value: 6, label: "Cilindar" },
      { value: 7, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1618,
    olxId: 2724,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Čelik" },
      { value: 2, label: "Aluminij" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1618,
    olxId: 2725,
    name: "strana",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi stranu" },
      { value: 1, label: "Desna" },
      { value: 2, label: "Lijeva" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1522,
    olxId: 2620,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Metal" },
      { value: 2, label: "Plastika" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1812,
    olxId: 2792,
    name: "grupa",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi grupu" },
      { value: 1, label: "20" },
      { value: 2, label: "30" },
      { value: 3, label: "40" },
      { value: 4, label: "50" },
      { value: 5, label: "60" },
      { value: 6, label: "70" },
      { value: 7, label: "80" },
      { value: 8, label: "90" },
      { value: 9, label: "95" },
      { value: 10, label: "100" },
      { value: 11, label: "110" },
      { value: 12, label: "120" },
      { value: 13, label: "130" },
      { value: 14, label: "190" },
      { value: 15, label: "200" },
      { value: 16, label: "210" },
      { value: 17, label: "220" },
      { value: 18, label: "225" },
      { value: 19, label: "230" },
      { value: 20, label: "240" },
      { value: 21, label: "245" },
      { value: 22, label: "247" },
      { value: 23, label: "250" },
      { value: 24, label: "260" },
      { value: 25, label: "265" },
      { value: 26, label: "270" },
      { value: 27, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1471,
    olxId: 2161,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Servo" },
      { value: 2, label: "Mehanička" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1435,
    olxId: 2099,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Zadnji" },
      { value: 3, label: "Centralni" },
      { value: 4, label: "Gumeni" },
      { value: 5, label: "Druk" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1079,
    olxId: 2805,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Hauba" },
      { value: 2, label: "Krilo" },
      { value: 3, label: "Vrata" },
      { value: 4, label: "Gepek" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2015,
    olxId: 4703,
    name: "sijalica",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi tip sijalice" },
      { value: 1, label: "Obična" },
      { value: 2, label: "Xenon" },
      { value: 3, label: "BiXenon" },
      { value: 4, label: "LED" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2015,
    olxId: 4702,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Desna" },
      { value: 2, label: "Lijeva" },
      { value: 3, label: "Obje" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1439,
    olxId: 2127,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednja" },
      { value: 2, label: "Zadnja" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2012,
    olxId: 4686,
    name: "strana",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi stranu" },
      { value: 1, label: "Prednji vozačev" },
      { value: 2, label: "Prednji suvozačev" },
      { value: 3, label: "Zadnji" },
      { value: 4, label: "Prednji komplet" },
      { value: 5, label: "Prednji i zadnji komplet" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1433,
    olxId: 2155,
    name: "brzine",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi broj brzina" },
      { value: 1, label: "4" },
      { value: 2, label: "5" },
      { value: 3, label: "6" },
      { value: 4, label: "7" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1433,
    olxId: 2154,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Automatik" },
      { value: 2, label: "Manuelni" },
      { value: 3, label: "Poluautomatik" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1061,
    olxId: 2433,
    name: "godiste",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi godiste" },
      { value: 1, label: "2024" },
      { value: 2, label: "2023" },
      { value: 3, label: "2022" },
      { value: 4, label: "2021" },
      { value: 5, label: "2020" },
      { value: 6, label: "2019" },
      { value: 7, label: "2018" },
      { value: 8, label: "2017" },
      { value: 9, label: "2016" },
      { value: 10, label: "2015" },
      { value: 11, label: "2014" },
      { value: 12, label: "2013" },
      { value: 13, label: "2012" },
      { value: 14, label: "2011" },
      { value: 15, label: "2010" },
      { value: 16, label: "2009" },
      { value: 17, label: "2008" },
      { value: 18, label: "2007" },
      { value: 19, label: "2006" },
      { value: 20, label: "2005" },
      { value: 21, label: "2004" },
      { value: 22, label: "2003" },
      { value: 23, label: "2002" },
      { value: 24, label: "2001" },
      { value: 25, label: "2000" },
      { value: 66, label: "Starije" },
    ],
  },
  {
    parentOlxId: 1061,
    olxId: 2429,
    name: "kubikaza",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi kubikažu motora" },
      { value: 1, label: "1.0" },
      { value: 2, label: "1.1" },
      { value: 3, label: "1.2" },
      { value: 4, label: "1.3" },
      { value: 5, label: "1.4" },
      { value: 6, label: "1.5" },
      { value: 7, label: "1.6" },
      { value: 8, label: "1.7" },
      { value: 9, label: "1.8" },
      { value: 10, label: "1.9" },
      { value: 11, label: "2.0" },
      { value: 12, label: "2.1" },
      { value: 13, label: "2.2" },
      { value: 14, label: "2.3" },
      { value: 15, label: "2.4" },
      { value: 16, label: "2.5" },
      { value: 17, label: "2.6" },
      { value: 18, label: "2.7" },
      { value: 19, label: "2.8" },
      { value: 20, label: "2.9" },
      { value: 21, label: "3.0" },
      { value: 22, label: "3.1" },
      { value: 23, label: "3.2" },
      { value: 24, label: "3.3" },
      { value: 25, label: "3.4" },
      { value: 26, label: "3.5" },
      { value: 27, label: "3.6" },
    ],
  },
  {
    parentOlxId: 1061,
    olxId: 2432,
    name: "gorivo",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi gorivo" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Plin" },
      { value: 4, label: "Hibrid" },
      { value: 5, label: "Elektro" },
    ],
  },
  {
    parentOlxId: 1460,
    olxId: 2140,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Za ruku" },
      { value: 2, label: "Za glavu" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1460,
    olxId: 2141,
    name: "pozicija",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi poziciju" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Srednji" },
      { value: 3, label: "Zadnji" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 938,
    olxId: 2912,
    name: "kontrola",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi kontrolu" },
      { value: 1, label: "Touchscreen" },
      { value: 2, label: "Tipke" },
      { value: 3, label: "Touchsceen + tipke" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 938,
    olxId: 2915,
    name: "memorija-gb",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi memoriju(GB)" },
      { value: 1, label: "1" },
      { value: 2, label: "2" },
      { value: 3, label: "3" },
      { value: 4, label: "4" },
      { value: 5, label: "6" },
      { value: 6, label: "8" },
      { value: 7, label: "16" },
      { value: 8, label: "32" },
      { value: 9, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 938,
    olxId: 2914,
    name: "ram",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi RAM" },
      { value: 1, label: "64" },
      { value: 2, label: "128" },
      { value: 3, label: "256" },
      { value: 4, label: "348" },
      { value: 5, label: "512" },
      { value: 6, label: "768" },
      { value: 7, label: "1024 (1GB)" },
      { value: 8, label: "1.5 GB" },
      { value: 9, label: "2 GB" },
      { value: 10, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 938,
    olxId: 2913,
    name: "velicina-ekrana-inch",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi velicinu ekrana(inch)" },
      { value: 1, label: "1" },
      { value: 2, label: "1.1" },
      { value: 3, label: "1.5" },
      { value: 4, label: "1.6" },
      { value: 5, label: "1.7" },
      { value: 6, label: "2" },
      { value: 7, label: "2.1" },
      { value: 8, label: "2.2" },
      { value: 9, label: "2.3" },
      { value: 10, label: "2.4" },
      { value: 11, label: "2.6" },
      { value: 12, label: "2.7" },
      { value: 13, label: "2.8" },
      { value: 14, label: "3" },
      { value: 15, label: "3.5" },
      { value: 16, label: "3.8" },
      { value: 17, label: "4" },
      { value: 18, label: "4.3" },
      { value: 19, label: "4.4" },
      { value: 20, label: "4.7" },
      { value: 21, label: "5" },
      { value: 22, label: "5.1" },
      { value: 23, label: "5.8" },
      { value: 24, label: "7" },
      { value: 25, label: "8" },
      { value: 26, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2623,
    olxId: 6971,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednji desni" },
      { value: 2, label: "Zadnji desni" },
      { value: 3, label: "Prednji lijevi" },
      { value: 4, label: "Zadnji lijevi" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1449,
    olxId: 7109,
    name: "vrsta-oglasa",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu-oglasa" },
      { value: 1, label: "Prodaja" },
      { value: 2, label: "Iznajmljivanje" },
    ],
  },
  {
    parentOlxId: 1449,
    olxId: 7600,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Nosači za automobile" },
      { value: 2, label: "Koferi za automobile" },
    ],
  },
  {
    parentOlxId: 1449,
    olxId: 2128,
    name: "namjena",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi Tip" },
      { value: 1, label: "Za biciklo" },
      { value: 2, label: "Za skije" },
      { value: 3, label: "Za prtljag" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1449,
    olxId: 2826,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Krov" },
      { value: 2, label: "Gepek" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2128,
    olxId: 6403,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Motora" },
      { value: 2, label: "Mjenjača" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2459,
    olxId: 6729,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Zadnji" },
    ],
  },
  {
    parentOlxId: 1490,
    olxId: 2111,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednje" },
      { value: 2, label: "Zadnje" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2425,
    olxId: 6670,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Gasa" },
      { value: 2, label: "Kvačila" },
      { value: 3, label: "Kočnice" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1461,
    olxId: 2143,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Gumene" },
      { value: 2, label: "Platnene" },
      { value: 3, label: "Aluminijske" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1623,
    olxId: 2741,
    name: "namjena",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi namjenu" },
      { value: 1, label: "Unutrašnja" },
      { value: 2, label: "Vanjska" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1759,
    olxId: 2758,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Obični" },
      { value: 2, label: "Sekvent" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1567,
    olxId: 2197,
    name: "jacina-w",
    inputType: "number",
    options: null,
  },
  {
    parentOlxId: 1566,
    olxId: 2195,
    name: "jacina-w",
    inputType: "number",
    options: null,
  },
  {
    parentOlxId: 1570,
    olxId: 2199,
    name: "jacina-w",
    inputType: "number",
    options: null,
  },
  {
    parentOlxId: 1570,
    olxId: 2200,
    name: "broj-izlaza",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi broj-izlaza" },
      { value: 1, label: "0" },
      { value: 2, label: "1" },
      { value: 3, label: "2" },
      { value: 4, label: "3" },
      { value: 5, label: "4" },
      { value: 6, label: "5" },
      { value: 7, label: "6" },
      { value: 8, label: "7" },
      { value: 9, label: "8" },
      { value: 10, label: "9" },
      { value: 11, label: "10" },
      { value: 12, label: "11" },
      { value: 13, label: "12" },
      { value: 14, label: "13" },
      { value: 15, label: "14" },
      { value: 16, label: "15" },
      { value: 17, label: "16" },
      { value: 18, label: "17" },
      { value: 19, label: "18" },
    ],
  },
  {
    parentOlxId: 2517,
    olxId: 6817,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Poklopac rezervoara" },
      { value: 2, label: "Čep rezervoara" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2456,
    olxId: 6717,
    name: "vrsta-zastite",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu-zastite" },
      { value: 1, label: "Poklopac" },
      { value: 2, label: "Podna zaštita" },
    ],
  },
  {
    parentOlxId: 1450,
    olxId: 2145,
    name: "namjena",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi namjenu" },
      { value: 1, label: "Svjetlo" },
      { value: 2, label: "Klima" },
      { value: 3, label: "Grijanje" },
      { value: 4, label: "Ventilacija" },
      { value: 5, label: "Podizači" },
      { value: 6, label: "Žmigavci" },
      { value: 7, label: "Retrovizori" },
      { value: 8, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1475,
    olxId: 2586,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Analogni" },
      { value: 2, label: "Digitalni" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1448,
    olxId: 2844,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Elektro" },
      { value: 2, label: "Goriva" },
      { value: 3, label: "Servo" },
      { value: 4, label: "Ulja" },
      { value: 5, label: "Vodena" },
      { value: 6, label: "Vakum" },
      { value: 7, label: "Grijanje" },
      { value: 8, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1454,
    olxId: 2103,
    name: "velicina-inch",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi velicinu(inch)" },
      { value: 1, label: "13" },
      { value: 2, label: "14" },
      { value: 3, label: "15" },
      { value: 4, label: "16" },
      { value: 5, label: "17" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 943,
    olxId: 1852,
    name: "boja",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi boju" },
      { value: 1, label: "Neutralna" },
      { value: 2, label: "Bež" },
      { value: 3, label: "Bijela" },
      { value: 4, label: "Crna" },
      { value: 5, label: "Crvena" },
      { value: 6, label: "Ljubičasta" },
      { value: 7, label: "Narandžasta" },
      { value: 8, label: "Plava" },
      { value: 9, label: "Siva" },
      { value: 10, label: "Smeđa" },
      { value: 11, label: "Srebrena" },
      { value: 12, label: "Zelena" },
      { value: 13, label: "Zlatna" },
      { value: 14, label: "Žuta" },
      { value: 15, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 943,
    olxId: 2124,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Desni" },
      { value: 2, label: "Lijevi" },
      { value: 3, label: "Unutrašnji" },
      { value: 4, label: "Univerzalni" },
      { value: 5, label: "Desni i Lijevi (set)" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2661,
    olxId: 7290,
    name: "velicina-precnikpromjer",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi velicinu(precnik/promjer)" },
      { value: 1, label: "13" },
      { value: 2, label: "14" },
      { value: 3, label: "15" },
      { value: 4, label: "16" },
      { value: 5, label: "17" },
      { value: 6, label: "18" },
      { value: 7, label: "19" },
      { value: 8, label: "20" },
      { value: 9, label: "21" },
      { value: 10, label: "22" },
      { value: 11, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2661,
    olxId: 7291,
    name: "visina",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi visinu" },
      { value: 1, label: "25" },
      { value: 2, label: "30" },
      { value: 3, label: "35" },
      { value: 4, label: "40" },
      { value: 5, label: "45" },
      { value: 6, label: "50" },
      { value: 7, label: "55" },
      { value: 8, label: "60" },
      { value: 9, label: "65" },
      { value: 10, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2661,
    olxId: 7292,
    name: "sirina",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi sirinu" },
      { value: 1, label: "125" },
      { value: 2, label: "135" },
      { value: 3, label: "145" },
      { value: 4, label: "155" },
      { value: 5, label: "165" },
      { value: 6, label: "175" },
      { value: 7, label: "185" },
      { value: 8, label: "195" },
      { value: 9, label: "205" },
      { value: 10, label: "215" },
      { value: 11, label: "225" },
      { value: 12, label: "235" },
      { value: 13, label: "245" },
      { value: 14, label: "255" },
      { value: 15, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2661,
    olxId: 7294,
    name: "broj-rupa",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi broj-rupa" },
      { value: 1, label: "3" },
      { value: 2, label: "4" },
      { value: 3, label: "5" },
      { value: 4, label: "Više" },
    ],
  },
  {
    parentOlxId: 2661,
    olxId: 7295,
    name: "raspon-sarafa",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi raspon-sarafa" },
      { value: 1, label: "4x98" },
      { value: 2, label: "4x100" },
      { value: 3, label: "4x108" },
      { value: 4, label: "4x100/4x108" },
      { value: 5, label: "4x112" },
      { value: 6, label: "4x114.3" },
      { value: 7, label: "4x100/4x114.30" },
      { value: 8, label: "4x108/4x113.30" },
      { value: 9, label: "4x120" },
      { value: 10, label: "5x98" },
      { value: 11, label: "5x100" },
      { value: 12, label: "5x105" },
      { value: 13, label: "5x114.3" },
      { value: 14, label: "5x108" },
      { value: 15, label: "5x110" },
      { value: 16, label: "5x112" },
      { value: 17, label: "5x115" },
      { value: 18, label: "5x120" },
      { value: 19, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1479,
    olxId: 2603,
    name: "materijal",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal" },
      { value: 1, label: "Metalni" },
      { value: 2, label: "Plastični" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2062,
    olxId: 5022,
    name: "materijal-vecinski",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi materijal-vecinski" },
      { value: 1, label: "Drvo" },
      { value: 2, label: "Plastika" },
      { value: 3, label: "Guma" },
      { value: 4, label: "Metal" },
      { value: 5, label: "Koža" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1470,
    olxId: 2574,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Airbag" },
      { value: 2, label: "Radilice" },
      { value: 3, label: "Bregaste" },
      { value: 4, label: "Temperature" },
      { value: 5, label: "Pritiska" },
      { value: 6, label: "Zraka" },
      { value: 7, label: "Parking" },
      { value: 8, label: "Kišu" },
      { value: 9, label: "Svjetla" },
      { value: 10, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1453,
    olxId: 2149,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Obična" },
      { value: 2, label: "Xenon" },
      { value: 3, label: "BiXenon" },
      { value: 4, label: "LED" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2549,
    olxId: 6876,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Sirena" },
      { value: 2, label: "Taster" },
      { value: 3, label: "Komplet" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 941,
    olxId: 4736,
    name: "pozicija-namjena",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi poziciju-namjenu" },
      { value: 1, label: "Lijevo prednje" },
      { value: 2, label: "Desno prednje" },
      { value: 3, label: "Komplet prednja" },
      { value: 4, label: "Komplet zadnja" },
      { value: 5, label: "Prednja i zadnja" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1619,
    olxId: 2731,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Vrata" },
      { value: 2, label: "Gepek" },
      { value: 3, label: "Krov" },
      { value: 4, label: "Patos" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 948,
    olxId: 2798,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Motora" },
      { value: 2, label: "Unutrašnji" },
      { value: 3, label: "Vanjski" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1447,
    olxId: 2660,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Dizel" },
      { value: 2, label: "Benzin" },
      { value: 3, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1455,
    olxId: 2540,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Sintetička" },
      { value: 2, label: "Polusintetička" },
      { value: 3, label: "Mineralna ulja" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1480,
    olxId: 2150,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Klime" },
      { value: 2, label: "Vode" },
      { value: 3, label: "Hladnjaka" },
      { value: 4, label: "Motora" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1477,
    olxId: 2597,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Usisni" },
      { value: 2, label: "EGR" },
      { value: 3, label: "Vakum" },
      { value: 4, label: "Gas" },
      { value: 5, label: "Elektro" },
      { value: 6, label: "Zrak" },
      { value: 7, label: "Ostaloa" },
    ],
  },
  {
    parentOlxId: 1459,
    olxId: 2552,
    name: "boja",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi boju" },
      { value: 1, label: "Neutralna" },
      { value: 2, label: "Bež" },
      { value: 3, label: "Bijela" },
      { value: 4, label: "Crna" },
      { value: 5, label: "Crvena" },
      { value: 6, label: "Ljubičasta" },
      { value: 7, label: "Narandžasta" },
      { value: 8, label: "Plava" },
      { value: 9, label: "Siva" },
      { value: 10, label: "Smeđa" },
      { value: 11, label: "Srebrena" },
      { value: 12, label: "Zelena" },
      { value: 13, label: "Zlatna" },
      { value: 14, label: "Žuta" },
      { value: 15, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1459,
    olxId: 2115,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednja desna" },
      { value: 2, label: "Zadnja desna" },
      { value: 3, label: "Prednja lijeva" },
      { value: 4, label: "Zadnja lijeva" },
      { value: 5, label: "Gepek vrata" },
      { value: 6, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1617,
    olxId: 2721,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Zadnji" },
      { value: 3, label: "Bočni" },
      { value: 4, label: "Unutrašnji" },
      { value: 5, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1034,
    olxId: 2801,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Šajba" },
      { value: 2, label: "Vrata" },
      { value: 3, label: "Gepek" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 2518,
    olxId: 6819,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Šprice(brizgaljke) farova" },
      { value: 2, label: "Brisači farova" },
      { value: 3, label: "Motorići farova" },
      { value: 4, label: "Ostalo" },
    ],
  },
  {
    parentOlxId: 1541,
    olxId: 2653,
    name: "vrsta",
    inputType: "select",
    options: [
      { value: 0, label: "Izaberi vrstu" },
      { value: 1, label: "Prednji" },
      { value: 2, label: "Zadnji" },
      { value: 3, label: "Bočni" },
      { value: 4, label: "Ostalo" },
    ],
  },
];

export { allAttributes };